import apiClient from './apiClient';
import { Meta } from '../types/meta';

// Metas asignadas por el profesional en Vita360 (Fase 2 de bidireccionalidad).
export const metaService = {
  async getMetas(): Promise<Meta[]> {
    const response = await apiClient.get<Meta[]>('/metas');
    return response.data;
  },

  async actualizarProgreso(id: number, progreso: number): Promise<Meta> {
    const response = await apiClient.post<Meta>(`/metas/${id}/progreso`, { progreso });
    return response.data;
  },
};
